<div class="col-12 md:col-12"><h3>{{'Mg_Right_Acc' | translate}}</h3></div>
<div class="height-vh grid">
  <div class="col-12 md:col-5 lg:col-4 nopadtop">
    <field-tools class="pad-none" [dataTitle]="'Tree' | translate">
      <div class="flex mb-1">
        <p-checkbox
          class="p-field"
          [(ngModel)]="checkFilter"
          binary="true"
          (onChange)="onChangeCkFilter($event)"
          name="checkFilter"
          inputId="checkFilter"
        ></p-checkbox>
       <label for="checkFilter" class="ml-2">{{'Dir_Right' | translate}}</label>
      </div>
      <div class="scroll-table">
        <p-tree
          [filter]="true"
          filterPlaceholder="{{'Filter' | translate}}"
          [value]="treeIndex"
          selectionMode="single"
          [(selection)]="selectedFile"
          (onNodeSelect)="nodeSelect($event)"
          (onNodeExpand)="nodeExpand($event)"
          [emptyMessage]="'No_Tree' | translate"
          >
          <ng-template let-node pTemplate="default">
            <span id={{node.key}}>
              {{ node.label }}
            </span>
          </ng-template>
        </p-tree>
      </div>
    </field-tools>
  </div>
  @if (blockedTree === false) {
    <div class="col-12 md:col-7 lg:col-8 nopadtop position-relative">
      <field-tools class="pad-none" [dataTitle]="'Rights' | translate">
        <dm-fieldset-header [backGround]="false">
          <button
            class="margin"
            pButton
            type="button"
            (click)="updateRightClick()"
            label="{{'Save' | translate}}"
          ></button>
        </dm-fieldset-header>
        <div class="grid">
          <span class="col-1">{{'Recurs' | translate}}</span>
          @if (updatePath !== '') {
            <div class="col-2">
              <p-inputSwitch name="recurs" [(ngModel)]="recurs"></p-inputSwitch>
            </div>
          }
        </div>
        <div class="scroll-table">
          <p-table
            #dt
            [columns]="profilList"
            [value]="accessRight"
            [paginator]="false"
            responsiveLayout="stack"
            [breakpoint]="'960px'"
            >
            <ng-template let-columns pTemplate="header">
              <tr>
                @for (col of columns; track col; let i = $index) {
                  <th>
                    <span>
                      {{ col.label }}
                    </span>
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
              <tr [pSelectableRow]="rowData" class="table-row">
                @for (col of columns; track col; let i = $index) {
                  <td>
                    @if (i ==0) {
                      <span>{{ rowData.grpName }}</span>
                    }
                    @if (i !=0) {
                      <p-checkbox
                        [(ngModel)]="rowData.access[i].activ"
                      binary="true"></p-checkbox>
                    }
                  </td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">{{'Empty' | translate}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </field-tools>
    </div>
  }
</div>
